import { PayloadAction, createSlice } from "@reduxjs/toolkit"
import { PURGE } from "redux-persist"
import { Message } from "./messagesSlice"
import { PinnedMessage } from "../api/xeps/PinnedMessages"

export type PartialMessage = Pick<
  Message,
  "from" | "to" | "body" | "id" | "type" | "url"
>

export type PinnedState = Record<string, PinnedMessage>

const initialState: PinnedState = {}

type PinMessageAction = {
  message: PartialMessage
  itemId: string
  at: number
  ttl: number
}

type UnpinMessageAction = {
  itemId: string
}

type BatchPinMessagesAction = {
  messages: PinMessageAction[]
}

type BatchUnpinMessagesAction = {
  itemIds: string[]
}

export const pinnedSlice = createSlice({
  name: "pinned",
  initialState,
  reducers: {
    pinMessage: (state, action: PayloadAction<PinMessageAction>) => {
      state[action.payload.message.id] = action.payload
    },
    batchPinMessages: (
      state,
      action: PayloadAction<BatchPinMessagesAction>,
    ) => {
      action.payload.messages.forEach((pinAction) => {
        state[pinAction.message.id] = pinAction
      })
    },
    unpinMessage: (state, action: PayloadAction<UnpinMessageAction>) => {
      const messageId = Object.entries(state).find(
        ([_, pinnedMessage]) => pinnedMessage.itemId === action.payload.itemId,
      )?.[0]
      if (messageId) {
        delete state[messageId]
      }
    },
    batchUnpinMessages: (
      state,
      action: PayloadAction<BatchUnpinMessagesAction>,
    ) => {
      for (const [stateMessageId, pinnedMessage] of Object.entries(state)) {
        if (action.payload.itemIds.includes(pinnedMessage.itemId)) {
          delete state[stateMessageId]
        }
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => initialState)
  },
})

export const {
  pinMessage,
  batchPinMessages,
  unpinMessage,
  batchUnpinMessages,
} = pinnedSlice.actions

export default pinnedSlice.reducer
